'use client';

import useSWR, { type SWRConfiguration } from 'swr';
import type { LiveRun } from '@/lib/live-trading/types';

export interface StrategiesResponse {
  runs: LiveRun[];
}

export interface UseStrategiesOptions {
  enabled?: boolean;
  swr?: SWRConfiguration<StrategiesResponse>;
}

const ACTIVE_POLL_INTERVAL_MS = 5_000;

/**
 * 实盘策略 run 列表（mode=live 的 shadow run，BFF 透传整条 ShadowRunSummary）。
 * GET /api/live-trading/runs；有 active run 时 5s 轮询（与 useLiveRuns 一致）。
 */
export function useStrategies(options: UseStrategiesOptions = {}) {
  const { enabled = true, swr } = options;

  const { data, error, isLoading, isValidating, mutate } = useSWR<StrategiesResponse>(
    enabled ? 'api:/live-trading/runs' : null,
    {
      revalidateOnFocus: false,
      refreshInterval: (d?: StrategiesResponse) =>
        (d?.runs ?? []).some((r) => r.status === 'active') ? ACTIVE_POLL_INTERVAL_MS : 0,
      ...swr,
    },
  );

  return {
    /** run 列表；未加载完成时为 null（区别于加载后的空列表） */
    strategies: data?.runs ?? null,
    data,
    error,
    isLoading,
    isValidating,
    refresh: mutate,
  };
}

export default useStrategies;
